import { mergeProps } from 'src/util'
import React from 'react'
import PropTypes from 'prop-types'
import { Rows, SpinningMask } from 'src/components'
import { blockPadding } from 'src/styles/_variables.scss'
import styles from './BlockContent.scss'
/**
 * The block content component.
 */
const BlockContent = ({ loading, children, padding, ...domProps }) => (
  <Rows {...mergeProps()({ className: styles.content, style: { padding } }, domProps)}>
    <SpinningMask loading={loading}>{children}</SpinningMask>
  </Rows>
)

BlockContent.defaultProps = {
  scrollable: true,
  padding: blockPadding,
}

BlockContent.propTypes = {
  /**
   * Whether the block content is busy loading some content.
   */
  loading: PropTypes.bool,
  /**
   * The block content.
   */
  children: PropTypes.node,
  /**
   * The block content padding.
   */
  padding: PropTypes.string,
}

export default BlockContent
